import styled from "@emotion/styled";


export const ContainerIcon = styled.div`
    padding: 4px;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 52px;
    height: 52px;
    border: 1px solid #1d4c81;
    


    .acompanhamento { 
        stroke: #1d4c81;
        scale: .6
    }
    
`